/* eslint-disable import/no-unresolved,camelcase */
import { Icon } from 'antd';
import React, {forwardRef ,useRef, useState } from 'react';
import axios from 'axios';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../constants';
import '../css/svlist_styles.css'

const headers = {'Content-Type': 'application/json', 'enctype':"multipart/form-data"}

const Child1 = React.forwardRef((props,ref) =>{

    return ( <input ref={ref} id="fileupload" type="file" name="fileupload" /> )
})
const SJProbate = (props) =>{

    console.log('SJProbate tc thincomponent', props)
    console.log('watch for tstid')
    const {tstid} = props
    console.log('watch for tstid', tstid)
    const child1 = useRef(null)

    const handleUpload = () =>{
  // console.log(arguments)
  console.log(child1.current.focus())
  console.log('handleUpload watch for tstid')
  console.log(props)
  console.log('handleUpload watch for tstid', props.tstid)
        let testatorId = props.tstid ? "" + props.tstid : "-11"
        let formData = new FormData(); 
        formData.append("testatorId",testatorId)
       formData.append("file", child1.current.files[0]);
      // const sjewillurl = `${SV_SOJ_ORCMOCK_ADDRESS}/eprobate/ewill`

      const sjewillurl =  `http://localhost:9082/wills/pbuploadFormdataFinal`

        //const sjewillurl =  `http://localhost:8080/wills/pbuploadFormdataFinal`

        axios.post(sjewillurl, formData, {
            headers: headers, 
            validateStatus:false
           
        })
        .then((rs) => {
            //fro axios we have axios data 
            const {data:{data}} = rs
            console.log('sv got data rom ')
        });

    }
    return(
       <div>
           <Child1 ref={child1} />
           {/*  <input id="fileupload" type="file" name="fileupload" />   */}
          
  <button id="upload-button" onClick={handleUpload}> Upload </button>
      </div>
    )
}

export default SJProbate;